import React, { useContext, useEffect, useState } from "react";
import { Card, Typography, Button, Empty, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { fetchData } from "PlatForms/OrgLMS/Services/MentorServices/TrainingDetailService";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Title, Text } = Typography;
const TrainingPage = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const mentorId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (selectedTab) {
      const fetchProjects = async () => {
        setLoading(true);
        try {
          const completed = selectedTab === "completed";
          const data = await fetchData(mentorId, token, completed);
          setProjects(data);
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(false);
        }
      };
      fetchProjects();
    }
  }, [selectedTab]);
  const handleManageClick = (id) => {
    navigate(`/view-training/${id}`);
  };
  return (
    <>
      {!selectedTab && (
        <Card title="Training" className="card-professional">
          {/* Initially Show Two Circular Boxes */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px", marginBottom: "20px",
              opacity: isBlocked ? 0.6 : 1,
              pointerEvents: isBlocked ? "none" : "auto"
            }}
          >
            <div
              onClick={() => isProfileComplete && setSelectedTab("inflight")}
              className="circular-card newCard-main-3"
            >
              <h3>Training Inflight</h3>
            </div>
            <div
              onClick={() => isProfileComplete && setSelectedTab("completed")}
              className="circular-card newCard-main-4"
            >
              <h3>Completed Training</h3>
            </div>
            <div
              onClick={() => isProfileComplete && navigate("/progress-report")}
              className="circular-card newCard-main-8"
            >
              <h3>Progress Report</h3>
            </div>
          </div>
        </Card>
      )}
      {selectedTab === "inflight" && (
        <Card
          loading={loading}
          className="card-professional"
          title="Training Inflight"
          extra={
            <Button type="default" onClick={() => setSelectedTab(null)}>
              Back
            </Button>
          }
        >
          {projects.length === 0 ? (
            <Empty description="No Training found" />
          ) : (
            projects.map((project) => (
                <div key={project.id} style={{ position: "relative", marginBottom: 20 }}>
                  {project.isRetryTraining && <div className="ribbon-Badge">Repeated</div>}
                  <Card
                    style={{ background: "#fafafa", borderRadius: 10 }}
                  >
                    <Title level={4} style={{ color: "#9A6B0E", marginBottom: 10 }}>
                      {project.title}
                    </Title>
                    <Text
                      style={{
                        fontSize: "14px",
                        color: "#333",
                        display: "block",
                        marginBottom: 10,
                      }}
                    >
                      {project.description}
                    </Text>
                    <Text
                      style={{
                        fontSize: "14px",
                        color: "#333",
                        display: "block",
                        marginBottom: 10,
                      }}
                    >
                      {project.groupName}
                    </Text>
                    <Text type="secondary" style={{ fontSize: "14px", display: "block" }}>
                      Start Date: {moment(project.startDate).format("MMMM Do YYYY")}
                    </Text>
                    <Text
                      type="secondary"
                      style={{ fontSize: "14px", display: "block", marginBottom: 10 }}
                    >
                      End Date: {moment(project.endDate).format("MMMM Do YYYY")}
                    </Text>
                    <Button type="primary" onClick={() => handleManageClick(project.id)}>
                      Manage
                    </Button>
                  </Card>
                </div>
            ))
          )}
        </Card>
      )}
      {/* Show "Under Construction" Card if Completed Project is selected */}
      {selectedTab === "completed" && (
        <Card
          loading={loading}
          className="card-professional"
          title="Completed Training"
          extra={
            <Button type="default" onClick={() => setSelectedTab(null)}>
              Back
            </Button>
          }
        >
          {projects.length === 0 ? (
            <Empty description="No Training found" />
          ) : (
            projects.map((project) => (
                <div key={project.id} style={{ position: "relative", marginBottom: 20 }}>
                  {project.isRetryTraining && <div className="ribbon-Badge">Repeated</div>}
                  <Card
                    style={{ marginBottom: 20, background: "#fafafa", borderRadius: 10 }}
                  >
                    <Title level={4} style={{ color: "#9A6B0E", marginBottom: 10 }}>
                      {project.title}
                    </Title>
                    <Text
                      style={{
                        fontSize: "14px",
                        color: "#333",
                        display: "block",
                        marginBottom: 10,
                      }}
                    >
                      {project.description}
                    </Text>
                    <Text type="secondary" style={{ fontSize: "14px", display: "block" }}>
                      Start Date: {moment(project.startDate).format("MMMM Do YYYY")}
                    </Text>
                    <Text
                      type="secondary"
                      style={{ fontSize: "14px", display: "block", marginBottom: 10 }}
                    >
                      End Date: {moment(project.endDate).format("MMMM Do YYYY")}
                    </Text>
                    <Tag style={{ backgroundColor: "Green", color: "white" }}>
                      Status : Completed
                    </Tag>
                  </Card>
                </div>
            ))
          )}
        </Card>
      )}
    </>
  );
};
export default TrainingPage;
